module.exports = __webpack_public_path__ + "img/site-jlo.8329f9ea.png";